const selectADRForCall = (state = {}, callerID) => {
  try {
    const { emergencyCalls = {} } = state;
    const { callQueue = {} } = emergencyCalls;
    const data = callQueue[callerID] ? callQueue[callerID] : null;
    if (data.additionalData) {
      return data.additionalData;
    }
    return null;
  } catch {
    return null;
  }
};

export default selectADRForCall;
